import React from 'react';
import { Truck } from 'lucide-react';

const STATUS_OPTIONS = [
  { value: 'TO_REVIEW', label: 'À étudier' },
  { value: 'CONFIGURATION_REQUIRED', label: 'Configuration requise' },
  { value: 'CONNECTOR_AVAILABLE', label: 'Connecteur Clickorico disponible' },
  { value: 'ACTIVE', label: 'Actif' },
];

/**
 * Super Admin — contrat transporteur existant (B2.1b, pas de connecteur technique).
 */
export default function ExistingCarrierAdminPanel({
  carrierName,
  integrationStatus,
  onCarrierNameChange,
  onIntegrationStatusChange,
  disabled = false,
}) {
  return (
    <div className="mt-4 rounded-lg border border-amber-200 bg-amber-50/50 p-4">
      <div className="mb-3 flex items-center gap-2 text-amber-900">
        <Truck className="h-5 w-5" aria-hidden />
        <h4 className="font-semibold">Transporteur existant</h4>
      </div>
      <p className="mb-4 text-sm text-amber-900/80">
        Le transporteur est enregistré pour ce commerçant. Aucun connecteur Clickorico n&apos;est
        actuellement configuré pour ce transporteur : l&apos;expédition automatisée via ce contrat
        n&apos;est donc pas encore active.
      </p>
      <div className="space-y-4">
        <div>
          <label htmlFor="existing-carrier-name" className="mb-1 block text-sm font-medium text-gray-800">
            Nom du transporteur <span className="text-red-600">*</span>
          </label>
          <input
            id="existing-carrier-name"
            type="text"
            className="w-full max-w-md rounded-md border border-gray-300 px-3 py-2 text-sm"
            value={carrierName || ''}
            onChange={(e) => onCarrierNameChange(e.target.value)}
            disabled={disabled}
            maxLength={200}
            placeholder="Ex. Chronopost, Colissimo, DHL…"
          />
        </div>
        <div>
          <label htmlFor="existing-carrier-status" className="mb-1 block text-sm font-medium text-gray-800">
            Statut d&apos;intégration
          </label>
          <select
            id="existing-carrier-status"
            className="w-full max-w-md rounded-md border border-gray-300 px-3 py-2 text-sm"
            value={integrationStatus || 'TO_REVIEW'}
            onChange={(e) => onIntegrationStatusChange(e.target.value)}
            disabled={disabled}
          >
            {STATUS_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export { STATUS_OPTIONS };
